import React, { Component } from 'react';
import {Row, Col, Card, Avatar} from 'antd';
import { Breadcrumb } from '../common/atoms';
import {WeightMeasureImage,DrinkAppleImage,RunningFlagImage,HeartDumbellImage,SearchTrackImage,
				PregnancyCareImage,DiabetesManagementImage,BloodPressureImage,
				NewBornImage,AppleImage,ChangeAnalyticsImage,CoupleImage,
				InsulinImage,SingleHeartImage,SingleDumbellImage,BloodSugarImage,
				HoldingDumbleImage,ManTargetImage,RoutineTrackingImage,SingleUserImage,
				TargetImage,PersonalCareImage,DetailInformationImage,SmokingCessationImage,LeftChevronIcon} from '../../assets/images';

class HealthCoach extends Component {
  constructor(props) {
      super(props);
  }

  componentDidMount() {
	document.getElementById('mainPage').scrollIntoView();
	}

  renderOverview(){
		sessionStorage.setItem('defaultSelectedTab', '9')
		this.props.history.push({pathname: '/overview'})
	}

  render () {
    let that = this
    return(
	<div id="mainPage">
		<Breadcrumb list={[{ text:'Analytics', link:'#' }, { text:'Health coach', link:'/health-coach' }]} classes='mb-1' />
		<Row>
	<Col span={24}>
		<Row type="flex" justify="start">
	<a className="flex flex-row w-full mb-2 items-center" style={{marginTop: 10}}onClick={this.renderOverview.bind(this)}><img className="mt-minus-4 chevronBackLink" style={{marginRight: 5}} src={LeftChevronIcon} /> <span className="GoBackLink" >Go Back</span></a>
            </Row>
	</Col>
        </Row>
		<Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <h2 className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0'>Health Coach Programmes</h2>
            </Row>
          </Col>
        </Row>
        <Card className="health-check-utilization-card" style={{marginBottom: 60,minHeight: 400,backgroundColor: '#E6F3F0',marginTop: 80}}>
	<Row>
	          <Col span={12}>
	            <Row type="flex" justify="start">
			<Avatar className="mt-minus-8" style={{ color: '#6B7280', backgroundColor: '#ffffff',marginRight: 8 }}>1</Avatar>
	              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>WEIGHT MANAGEMENT</h4>
	            </Row>
	            <Col span={20}>
			<h2 className='font-fig-extrabold text-2xl font-medium leading-tight tracking-tight text-gray-900' style={{marginLeft: 40}}>Achieve your health goals with guidance from experts</h2>
	            </Col>
	            <img src={WeightMeasureImage} alt="weight" style={{marginLeft: 40,marginTop: 80}} />
	          </Col>
	          <Col span={12}>
			<Card className="health-check-utilization-card" style={{marginBottom: 20}}>
				<h4 className="semibold" style={{fontSize: 16}}>Overview</h4>
				<h5 style={{color: '#6B7280'}}>Our weight management program will help you achieve your weight goals with guidance from expert nutritionists and healthcoaches.</h5>
								<h5 style={{color: '#6B7280'}}>Program pays attention to physical, mental as well as psychological aspects of maintaining a healthy body weight.</h5>
			</Card>
			<Card className="health-check-utilization-card">
				<h5 className="sub-title">PROGRAMME FEATURES</h5>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={DrinkAppleImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Personalized diet plans to suit your taste buds.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={HeartDumbellImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Behavioral and lifestyle modifications focused on overall health.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={RunningFlagImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Fun activities and exercise plan to acheive target body image.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={SearchTrackImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Routine tracking and trending of weight and other parameters.</h5>
				</Row>
			</Card>
	          </Col>
	</Row>
        </Card>
        <Card className="health-check-utilization-card" style={{marginBottom: 60,minHeight: 400,backgroundColor: '#EFF6FF',marginTop: 80}}>
	<Row>
	          <Col span={12}>
	            <Row type="flex" justify="start">
			<Avatar className="mt-minus-8" style={{ color: '#6B7280', backgroundColor: '#ffffff',marginRight: 8 }}>2</Avatar>
	              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>PREGNANCY CARE</h4>
	            </Row>
	            <Col span={20}>
			<h2 className='font-fig-extrabold text-2xl font-medium leading-tight tracking-tight text-gray-900' style={{marginLeft: 40}}>Giving good care before, during, and after the pregnancy is important</h2>
	            </Col>
	            <img src={PregnancyCareImage} alt="weight" style={{marginLeft: 40,marginTop: 80}} />
	          </Col>
	          <Col span={12}>
			<Card className="health-check-utilization-card" style={{marginBottom: 20}}>
				<h4 className="semibold" style={{fontSize: 16}}>Overview</h4>
				<h5 style={{color: '#6B7280'}}>A comprehensive pregnancy care program designed keeping in mind the special needs of an expecting mother. Includes everything that is required by the expecting mother to lead a happy pregnancy and deliver a healthy baby.</h5>
								<h5 style={{color: '#6B7280'}}>It doesn’t stop there! It also includes lactation guidance and postnatal care to ensure that you take the best possible care of the new member in your family.</h5>
			</Card>
			<Card className="health-check-utilization-card">
				<h5 className="sub-title">PROGRAMME FEATURES</h5>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={NewBornImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Pre Natal and Post Natal Support to Expecting Mothers.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={CoupleImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Involvement of both partners throughout the program.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={ChangeAnalyticsImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Preparing for changes and handling additional responsibility.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={AppleImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Customized meal planning provided by Nutritionist.</h5>
				</Row>
			</Card>
	          </Col>
	</Row>
        </Card>
        <Card className="health-check-utilization-card" style={{marginBottom: 60,minHeight: 400,backgroundColor: '#FDF1E4',marginTop: 80}}>
	<Row>
	          <Col span={12}>
	            <Row type="flex" justify="start">
			<Avatar className="mt-minus-8" style={{ color: '#6B7280', backgroundColor: '#ffffff',marginRight: 8 }}>3</Avatar>
	              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>DIABETES MANAGEMENT</h4>
	            </Row>
	            <Col span={20}>
			<h2 className='font-fig-extrabold text-2xl font-medium leading-tight tracking-tight text-gray-900' style={{marginLeft: 40}}>Holistic program to keep your diabetes under control</h2>
	            </Col>
	            <img src={DiabetesManagementImage} alt="weight" style={{marginLeft: 40,marginTop: 80}} />
	          </Col>
	          <Col span={12}>
			<Card className="health-check-utilization-card" style={{marginBottom: 20}}>
				<h4 className="semibold" style={{fontSize: 16}}>Overview</h4>
				<h5 style={{color: '#6B7280'}}>A patient-centred and personalized program for diabetes management which includes regular sessions with doctors, nutritionist and other experts.</h5>
								<h5 style={{color: '#6B7280'}}>Supported by technology the program has a holistic approach taking into consideration lifestyle, medications and family history to help you keep your diabetes under control and lead a healthier life.</h5>
			</Card>
			<Card className="health-check-utilization-card">
				<h5 className="sub-title">PROGRAMME FEATURES</h5>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={InsulinImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Managing side effects of medication and/or insulin.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={SingleHeartImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Behavioral and lifestyle modifications focused on overall health.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={SingleDumbellImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Appropriate exercise individualized to patient’s needs.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={BloodSugarImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Guidance on diet quality and quantity to prevent fluctuation in blood sugars.</h5>
				</Row>
			</Card>
	          </Col>
	</Row>
        </Card>
        <Card className="health-check-utilization-card" style={{marginBottom: 60,minHeight: 400,backgroundColor: '#FDEDEB',marginTop: 80}}>
	<Row>
	          <Col span={12}>
	            <Row type="flex" justify="start">
			<Avatar className="mt-minus-8" style={{ color: '#6B7280', backgroundColor: '#ffffff',marginRight: 8 }}>4</Avatar>
	              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>HYPERTENSION</h4>
	            </Row>
	            <Col span={20}>
			<h2 className='font-fig-extrabold text-2xl font-medium leading-tight tracking-tight text-gray-900' style={{marginLeft: 40}}>Bring your blood pressure within normal range with guidance from experts</h2>
	            </Col>
	            <img src={BloodPressureImage} alt="weight" style={{marginLeft: 40,marginTop: 80}} />
	          </Col>
	          <Col span={12}>
			<Card className="health-check-utilization-card" style={{marginBottom: 20}}>
				<h4 className="semibold" style={{fontSize: 16}}>Overview</h4>
				<h5 style={{color: '#6B7280'}}>High blood pressure can often show no symptoms, however if left uncontrolled, it can lead to various serious complications such as heart attack, stroke, or kidney failure.</h5>
								<h5 style={{color: '#6B7280'}}>We understand that each hypertension patient is different and requires a personalized treatment regimen. Our experts will help you make suitable lifestyle and dietary modifications to manage your blood pressure levels.</h5>
			</Card>
			<Card className="health-check-utilization-card">
				<h5 className="sub-title">PROGRAMME FEATURES</h5>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={SingleHeartImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Behavioral and lifestyle modifications focused on overall health.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={HoldingDumbleImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Fun exercises and activities suitable for hypertensives.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={ManTargetImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Psychosomatic affirmations to reduce blood pressure.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={RoutineTrackingImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Routine tracking and trending of blood pressure and other parameters.</h5>
				</Row>
			</Card>
	          </Col>
	</Row>
        </Card>
        <Card className="health-check-utilization-card" style={{marginBottom: 60,minHeight: 400,backgroundColor: '#F5F3FF',marginTop: 80}}>
	<Row>
	          <Col span={12}>
	            <Row type="flex" justify="start">
			<Avatar className="mt-minus-8" style={{ color: '#6B7280', backgroundColor: '#ffffff',marginRight: 8 }}>5</Avatar>
	              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>SMOKING CESSATION</h4>
	            </Row>
	            <Col span={20}>
			<h2 className='font-fig-extrabold text-2xl font-medium leading-tight tracking-tight text-gray-900' style={{marginLeft: 40}}>Believe you can and you are atleast half way there to quit smoking</h2>
	            </Col>
	            <img src={SmokingCessationImage} alt="weight" style={{marginLeft: 40,marginTop: 80}} />
	          </Col>
	          <Col span={12}>
			<Card className="health-check-utilization-card" style={{marginBottom: 20}}>
				<h4 className="semibold" style={{fontSize: 16}}>Overview</h4>
				<h5 style={{color: '#6B7280'}}>The program combines quit smoking strategies to keep you focused, confident, and motivated to quit. Our experts will handhold you throughout the program and help you overcome challenges that you will face as you quit.</h5>
								<h5 style={{color: '#6B7280'}}>We aim to change how you feel about your issue&nbsp;so that getting free becomes easy, enjoyable and you do not miss anything.</h5>
			</Card>
			<Card className="health-check-utilization-card">
				<h5 className="sub-title">PROGRAMME FEATURES</h5>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={SingleUserImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Addressing physical and mental health issues of relevance.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={TargetImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Target the cause for smoking or failure to quit.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={PersonalCareImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Complete hand holding by experts through the process.</h5>
				</Row>
				<Row type="flex" justify="start" style={{marginTop: 10}}>
					<img src={DetailInformationImage}/>
					<h5 style={{color: '#6B7280',marginTop: 5,marginLeft: 5}}>Sharing information on relevant quit-smoking aids.</h5>
				</Row>
			</Card>
	          </Col>
	</Row>
        </Card>
	</div>
	)
  }
}
export default HealthCoach;
